import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    // Automatically dismiss after 5 seconds
    setTimeout(() => {
      this.dismiss()
    }, 5000)
  }

  dismiss() {
    this.element.remove()
  }
}
